import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Box from '@mui/material/Box';

import SearchableDropdown from '../../../../components/SearchableDropdown';

const departmentAPICallback = (corpId) => ({
  httpMethod: 'POST',
  route: 'corporations/departments/read',
  generateBody: (searchTerm) => {
    const filters = [
      searchTerm && { operation: 'icontains', field: 'name', value: searchTerm },
    ].filter((i) => i);
    return {
      ...(corpId && { corporation: corpId }),
      filters,
    };
  },
});

const getDepartmentOptionLabel = (option) => option?.name || '';

const PlacementDepartmentSelector = ({
  placement,
  corporationId,
  wrapperSx,
  onDepartmentUpdate,
}) => {
  const departmentOption = useMemo(() => {
    if (!placement?.department) return null;
    return {
      _id: placement.department._id,
      name: placement.department.name,
    };
  }, [placement?.department]);

  const handleDepartmentChange = useCallback(
    (event, newValue) => {
      if (!newValue || !placement?.id || !onDepartmentUpdate) {
        return;
      }

      onDepartmentUpdate(placement.id, newValue);
    },
    [placement?.id, onDepartmentUpdate]
  );

  const memoizedDepartmentAPICallback = useMemo(
    () => departmentAPICallback(corporationId),
    [corporationId]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <SearchableDropdown
        value={departmentOption}
        onChange={handleDepartmentChange}
        disabled={!corporationId}
        placeholder={LanguageConverterV2('jobOrder.roster.department')}
        optionsAPICallback={memoizedDepartmentAPICallback}
        getOptionLabel={getDepartmentOptionLabel}
        wrapperSx={wrapperSx || { width: '200px' }}
        disableClear
      />
    </Box>
  );
};

PlacementDepartmentSelector.propTypes = {
  placement: PropTypes.shape({
    id: PropTypes.string,
    department: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  corporationId: PropTypes.string,
  wrapperSx: PropTypes.shape({}),
  onDepartmentUpdate: PropTypes.func,
};

export default PlacementDepartmentSelector;
